import React from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { useCarousel } from './hooks/useCarousel';

export const Carousel: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className }) => {
	const {
		data: { canScrollLeft, canScrollRight, prevLabel, nextLabel, containerRef },
		actions: { handlePrevious, handleNext },
	} = useCarousel();

	const totalItems = React.Children.count(children);

	if (totalItems === 0) {
		return null;
	}

	return (
		<div className={cn('relative w-full', className)}>
			{totalItems > 1 && (
				<button
					type="button"
					onClick={handlePrevious}
					disabled={!canScrollLeft}
					className="absolute left-0 top-1/2 z-10 hidden -translate-y-1/2 rounded-full border border-solid border-stroke-weaker bg-fill-inverse-strong p-2 elevation-low hover:elevation-elevated disabled:cursor-default disabled:opacity-50 md:flex"
					aria-label={prevLabel}
				>
					<ChevronLeftIcon />
				</button>
			)}

			<div
				ref={containerRef}
				className="w-full snap-x snap-mandatory overflow-x-auto scroll-smooth [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
			>
				<div className="flex gap-4 px-4 md:gap-0 md:px-0">
					{React.Children.map(children, (child) => (
						<div className="w-full flex-shrink-0 snap-start">{child}</div>
					))}
				</div>
			</div>

			{totalItems > 1 && (
				<button
					type="button"
					onClick={handleNext}
					disabled={!canScrollRight}
					className="absolute right-0 top-1/2 z-10 hidden -translate-y-1/2 rounded-full border border-solid border-stroke-weaker bg-fill-inverse-strong p-2 elevation-low hover:elevation-elevated disabled:cursor-default disabled:opacity-50 md:flex"
					aria-label={nextLabel}
				>
					<ChevronRightIcon />
				</button>
			)}
		</div>
	);
};
